module.exports = __webpack_public_path__ + "media/images/athletes/1666-c7978372ff20a62006f01edfea06be21.png";